import Tree from './_tree';

export default Tree;
